/**
 *
 * @param e the value caught by a `catch` statement, which could be of any type
 * @param prefix a message prefix, like "Failed to fetch user"
 * @returns a message that includes the error.message if the `e` parameter is an Error instance, or
 * the `prefix` alone if the `e` parameter is not an Error instance
 */
export const getFormattedErrorMessage = (e: unknown, prefix: string) => {
    if (e instanceof Error) {
        return `${prefix} due to error: ${e.message}`;
    }

    return prefix;
};
